import { createSlice } from '@reduxjs/toolkit';
import { validateRutGoldSilver } from '../actions/RutsActions';
import {
  RUT_NOT_FOUND,
  INVALID_RUT,
  SUBTITLE_ERROR,
} from '../../constants/texts';

const rutGoldSilverSlice = createSlice({
  name: 'ruts',
  initialState: {
    validationStatus: 'idle',
    errorMessageGold: null,
  },
  reducers: {
    resetValidation(state) {
      state.validationStatus = 'idle';
    },
  },
  extraReducers: {
    [validateRutGoldSilver.pending]: (state) => {
      state.validationStatus = 'loading';
    },
    [validateRutGoldSilver.fulfilled]: (state, action) => {
      state.validationStatus = action.payload.status ? 'succeded' : 'error';
      state.errorMessageGold = action.payload.status
        ? null
        : action.payload.msg;
    },
    [validateRutGoldSilver.rejected]: (state, action) => {
      state.validationStatus = 'error';
      if (action?.error?.message.includes('status code 404'))
        state.errorMessageGold = RUT_NOT_FOUND;
      else if (action?.error?.message.includes('status code 400'))
        state.errorMessageGold = INVALID_RUT;
      else state.errorMessageGold = SUBTITLE_ERROR;
    },
  },
});

export const { resetValidation } = rutGoldSilverSlice.actions;
export default rutGoldSilverSlice.reducer;
